module.exports = __webpack_public_path__ + "media/images/banner/planning/th-ac5fb630d83112365fdf92b7e6b4d8cb.jpg";